import AppointmentMessage from "./AppointmentMessage";

export default AppointmentMessage;
